<section id="dashboard-calendar-donut-stats" class="h-100">
    <div class="card h-100 mt-0 d-flex flex-column">
        <div *ngIf="!isEmpty" class="card-header">
            <h4 class="card-title">Eventos</h4>
            <p class="grey mb-0">
                <span *ngIf="!fromDate && !toDate">
                    Año Actual
                </span>
                <span *ngIf="fromDate && !toDate">
                    {{ fromDate | date: 'dd/MM/yyyy' }} - 31/12/{{ fromDate | date: 'yyyy' }}
                </span>
                <span *ngIf="!fromDate && toDate">
                    01/01/{{ toDate | date: 'yyyy' }} - {{ toDate | date: 'dd/MM/yyyy' }}
                </span>
                <span *ngIf="fromDate && toDate">
                    {{ fromDate | date: 'dd/MM/yyyy' }} - {{ toDate | date: 'dd/MM/yyyy' }}
                </span>
            </p>
        </div>
        <div class="group-start-content h-100 d-flex flex-column" [ngClass]="{
            'd-flex align-items-center justify-content-center': isEmpty
        }">
            <div *ngIf="!isEmpty; else noResults" class="card-content w-100 h-100 d-flex flex-column">
                <div id="donut-dashboard-chartist-chart" class="donut d-flex justify-content-center align-items-center">
                    <x-chartist *ngIf="chart" class="height-200" [data]="chart.data" [type]="chart.type"
                        [options]="chart.options" [responsiveOptions]="chart.responsiveOptions" [events]="chart.events">
                    </x-chartist>
                </div>
                <div class="card-body pt-0 d-flex flex-column justify-content-end">
                    <div class="row mb-3">
                        <div class="col">
                            <span class="mb-1 text-muted d-block">
                                <span [countUp]="donutStats.percentages.totalHolidays"></span>
                                % - Vacaciones</span>
                            <div class="progress" style="height: 5px;">
                                <div class="progress-bar bg-holidays" role="progressbar" [ngStyle]="{
                                'width': donutStats.percentages.totalHolidays + '%'
                            }" [attr.aria-valuenow]="donutStats.percentages.totalHolidays" aria-valuemin="0"
                                    [attr.aria-valuemax]="donutStats.totals.totalCount">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <span class="mb-1 text-muted d-block">
                                <span [countUp]="donutStats.percentages.totalPersonalMatters"></span>
                                % - Asuntos Propios</span>
                            <div class="progress" style="height: 5px;">
                                <div class="progress-bar bg-personal-matters" role="progressbar" [ngStyle]="{
                                'width': donutStats.percentages.totalPersonalMatters + '%'
                            }" [attr.aria-valuenow]="donutStats.percentages.totalPersonalMatters" aria-valuemin="0"
                                    [attr.aria-valuemax]="donutStats.totals.totalCount">
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <span class="mb-1 text-muted d-block">
                                <span [countUp]="donutStats.percentages.totalRemoteWork"></span>
                                % - Teletrabajo
                            </span>
                            <div class="progress" style="height: 5px;">
                                <div class="progress-bar bg-remote-work" role="progressbar" [ngStyle]="{
                                'width': donutStats.percentages.totalRemoteWork + '%'
                            }" [attr.aria-valuenow]="donutStats.percentages.totalRemoteWork" aria-valuemin="0"
                                    [attr.aria-valuemax]="donutStats.totals.totalCount">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <span class="mb-1 text-muted d-block">
                                <span [countUp]="donutStats.percentages.totalSickLeave"></span>
                                % - Bajas</span>
                            <div class="progress" style="height: 5px;">
                                <div class="progress-bar bg-sick-leave" role="progressbar" [ngStyle]="{
                                'width': donutStats.percentages.totalSickLeave + '%'
                            }" [attr.aria-valuenow]="donutStats.percentages.totalSickLeave" aria-valuemin="0"
                                    [attr.aria-valuemax]="donutStats.totals.totalCount">
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <span class="mb-1 text-muted d-block">
                                <span [countUp]="donutStats.percentages.totalPaidLeave"></span>
                                % - Permisos Retribuidos</span>
                            <div class="progress" style="height: 5px;">
                                <div class="progress-bar bg-paid-leave" role="progressbar" [ngStyle]="{
                                'width': donutStats.percentages.totalPaidLeave + '%'
                            }" [attr.aria-valuenow]="donutStats.percentages.totalPaidLeave" aria-valuemin="0"
                                    [attr.aria-valuemax]="donutStats.totals.totalCount">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #noResults>
                <div class="no-results">
                    <span>No se encontraron eventos que coincidan con los filtros.</span>
                </div>
            </ng-template>
        </div>

        <app-load-screen *ngIf="isLoading" loadingText="Cargando estadísticas del calendario..."></app-load-screen>
    </div>
</section>